//
import { RouteNames } from '@/router/routeNames';
import DashboardLayout from '../../layouts/DashboardLayout.vue';
import InvestmentsCard from './Investments.vue';

export default {
  path: '/investments/:tab?',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: RouteNames.INVESTMENTS,
      component: InvestmentsCard,
    },
    {
      path: 'learn-more',
      name: RouteNames.INVESTMENT_LEARN_MORE,
      component: InvestmentsCard,
    },
    {
      path: 'calculator',
      name: RouteNames.INVESTMENT_CALCULATOR,
      component: InvestmentsCard,
    },
  ],
};
